import { type FC, memo, useState, type ChangeEventHandler } from 'react';
import settingIcon from '@assets/images/vault/slippage.svg';
import settingHoverIcon from '@assets/images/vault/slippage-hover.svg';
// import sliderIcon from '@assets/images/icons/slider.svg';
import closeIcon from '@assets/images/vault/close.svg';

import styles from './index.module.scss';
import { useComputed } from 'foca';
import { globalSettingModel } from '@models/global-setting.model';
import Input from '@ui/input';
import Popover from '@ui/parrot/popover';
import Button from '@ui/button';

const LiquiditySlippage: FC = () => {
  const [showSetting, setShowSetting] = useState(false);
  const slippage = useComputed(globalSettingModel.liquiditySlippage);

  return (
    <Popover
      trigger="click"
      open={showSetting}
      content={
        <Setting
          onClose={() => {
            setShowSetting(false);
          }}
        />
      }
      onOpenChange={setShowSetting}
      placement={'bottom'}
      rootClassName={styles.slippage}
    >
      <div className={styles.button}>
        <img src={settingIcon} />
        <img src={settingHoverIcon} className={styles.hover} />
        <span>{slippage}%</span>
      </div>
    </Popover>
  );
};

const Setting: FC<{ onClose: () => void }> = ({ onClose }) => {
  const liquiditySlippage = useComputed(globalSettingModel.liquiditySlippage);
  const [inputValue, setInputValue] = useState(liquiditySlippage);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = Number(e.target.value) >= 0 ? e.target.value : '0.1';
    setInputValue(value);
  };

  const handleSave = () => {
    globalSettingModel.setLiquiditySlippage(Number(inputValue).toString(), false);
    onClose();
  };

  return (
    <>
      <div className={styles.setting_title}>
        <span>Setting</span>
        <img src={closeIcon} data-icon onClick={onClose} />
      </div>
      <div className={styles.setting_top}>Set your slippage tolerance for swap transactions.</div>

      <div className={styles.setting}>
        <div className={styles.custom}>
          {['0.1', '0.5', '1', '2'].map((item) => (
            <span
              key={item}
              className={item === inputValue ? styles.selected : ''}
              onClick={() => {
                setInputValue(item);
              }}
            >
              {item}
              {Number.isFinite(Number(item)) && '%'}
            </span>
          ))}
        </div>
        <div className={styles.input_wrapper}>
          <Input
            type="text"
            value={inputValue}
            wrapperClassName={styles.input}
            placeholder={liquiditySlippage}
            onChange={handleChange}
            suffix="%"
          />
        </div>
      </div>
      <div className={styles.btn}>
        <Button className={styles.save} onClick={handleSave}>
          Save
        </Button>
      </div>
    </>
  );
};

export default memo(LiquiditySlippage);
